import React, { useEffect, useState } from 'react'
import CustomModal from '../../components/CustomModal/CustomModal';
import useMediaQuery from '../../hooks/useMediaQuery';
import CustomTable from '../../components/CustomTable/CustomTable';
import CustomFilterTable from '../../components/CustomFilterTable/CustomFilterTable';
import CustomPagination from '../../components/CustomPagination/CustomPagination';
import useClassi from '../../hooks/useClassi';
import { alertService } from '../../services/AlertService';
import UtilityService from '../../services/UtillityServices/UtilityService';
import LoadingTable from '../../components/LoadingTable/LoadingTable';
import { ACTION_TYPES } from '../../model/actions';
import useClassiConfigTable from '../../configTable/useClassiConfigTable';
import ClassInfo from '../../components/ClassInfo/ClassInfo';
import { useNavigate } from 'react-router';
import CustomSearch from '../../components/CustomSearch/CustomSearch';
import useCorsi from '../../hooks/useCorsi';
import ClasseManagerForm from '../../components/Forms/ClasseManagerForm/ClasseManagerForm';
import moment from 'moment';
import { TIPO_CORSO } from '../../model/tipoCorso';
import { useSelector } from 'react-redux';
import { ROLES } from '../../model/roles';

const GestioneClassiPageV2 = () => {

  const {
    getClassiByParams,
    loadingStateClassi,
    createClasse,
    deleteClasse,
    modalStateClassi,
    setModalStateClassi,
    updateStateClasse,
    updateClasse
  } = useClassi();

  const {getCorsiByParams} = useCorsi();
  const isWideScreen = useMediaQuery('(min-width: 1200px)');
  const [classi, setClassi] = useState([]);
  const [selectedClasse, setSelectedClasse] = useState(null);
  const [formCreateClasse, setFormCreateClasse] = useState({});
  const navigate = useNavigate(); 
  const [orderBy, setOrderBy] = useState(null);
  const [orderType, setOrderType] = useState(null);
  const [selectedPage, setSelectedPage] = useState(1); 
  const [formDataFilter, setFormDataFilter] = useState({});
  const [totalPages, setTotalPages] = useState(1);
  const [isLoadingClassi, setIsLoadingClassi] = useState(false);
  const classiConfigTable = useClassiConfigTable();
  const userLoggedIn = useSelector(state => state?.user?.userData);

  useEffect(() => {
    if (!isLoadingClassi) {
        printAllClassi();
    }
  }, [orderBy, orderType, selectedPage]); 


  const fetchClassi = async (obj) => {
    setIsLoadingClassi(true);
  
    obj = {
      ...obj,
      filtri: {
        ...obj.filtri,
      }
    };
 
    const fetchClassiList = await getClassiByParams(obj);
    const countPagination = Math.ceil(fetchClassiList?.count / obj.limite);
    let classiList = fetchClassiList?.data ?? [];
    setTotalPages(countPagination);
    setClassi(classiList);
    setIsLoadingClassi(false);
    if(classiList?.length === 0){
      setSelectedPage(1)
    }
  }
  
  const printAllClassi = async () => {
    let obj = {
      filtri: {
        ...formDataFilter,
      },
      limite: 10,
      pagina: selectedPage ?? 1,
      ordinamento: `${orderBy ?? "id_classe"} ${orderType ?? "asc"}`
    };
  
    await fetchClassi(obj);
  };
  
  const onFilteredTable = async () => {
    setSelectedPage(1);
  
    let obj = {
      filtri: {
        ...formDataFilter,
      },
      limite: 10,
      pagina: 1,
      ordinamento: `${orderBy ?? "id_classe"} ${orderType ?? "asc"}`
    };
  
    await fetchClassi(obj);
  };

  const openInfoModal = (classe) => {
    setSelectedClasse(classe)
    setModalStateClassi(state => ({ ...state, showModalInfoClasse: true }));
  }

  const openEditModal = (classe) => {
    setSelectedClasse(classe)
    setFormCreateClasse({
      denominazione: classe.denominazione,
      id_corso: classe.corso.id_corso,
      id_sede: classe.sede?.id_sede
    });
    setModalStateClassi(state => ({ ...state, showModalUpdateClasse: true }));
  }

  const openDeleteModal = (classe) => {
    setSelectedClasse(classe)
    setModalStateClassi(state => ({ ...state, showModalDeleteClasse: true }));
  }

  const handleCloseModal = () => {
    setModalStateClassi(state => ({ 
       ...state,
       showModalCreateClasse: false, 
       showModalInfoClasse: false, 
       showModalDeleteClasse: false,
       showModalUpdateClasse: false,
       showModalUpdateStateClasse: false
      }));
  }

  const openModalCreateClasse = () => {
    setModalStateClassi(state => ({ ...state, showModalCreateClasse: true }));
  }


  const renderSelectedDeleteClasse = () => {
    return (
      <>
      <span className="d-block fs-4 mb-2"><b>Vuoi eliminare la seguente classe?</b> </span>
      <span className="d-block fs-5">{selectedClasse?.denominazione} - {selectedClasse?.corso?.denominazione}</span>
      </>
    )
  }

  const onCreateClasse = async () => {
    if (!formCreateClasse.denominazione || !formCreateClasse.data_inizio || !formCreateClasse.data_fine || !formCreateClasse.corso) {
      alertService.warn("Compila tutti i campi",{autoClose: true});
      return;
    }
    
    if((formCreateClasse?.corso?.modalita_erogazione === TIPO_CORSO.PRESENZA && !formCreateClasse?.id_sede) || (formCreateClasse?.corso?.modalita_erogazione === TIPO_CORSO.MISTA_PRESENZA_TELEMATICA && !formCreateClasse?.id_sede)) {
      alertService.warn("Compila tutti i campi",{autoClose: true});
      return;
    }

    const payload = {
      denominazione: formCreateClasse.denominazione,
      id_corso: formCreateClasse?.corso?.id_corso,
      data_inizio: moment(formCreateClasse.data_inizio).format('YYYY-MM-DD'),
      data_fine: moment(formCreateClasse.data_fine).format('YYYY-MM-DD'),
      id_sede: formCreateClasse?.id_sede
    };

    const response = await createClasse(payload);
    if (response) {
      handleCloseModal();
      printAllClassi();
    }
  };

  const onDeleteClasse = async () => {
    const obj = {id_classe: selectedClasse?.id_classe}
    const res = await deleteClasse(obj);
    if(res) {
      printAllClassi();
    }
  }

  const onUpdateStateClasse = async () => {
    const obj = {
      id_classe: selectedClasse?.id_classe,
      stato: (selectedClasse?.stato === "Attivo") ? "Inattivo" : "Attivo" 
    };
    await updateStateClasse(obj);
    handleCloseModal();
    printAllClassi();
  }

  const onUpdateClasse = async () => {
    const obj = {
      id_classe: selectedClasse?.id_classe,
      denominazione: formCreateClasse.denominazione
    }
    const res = await updateClasse(obj);
    if(res) {
      printAllClassi();
      handleCloseModal();
    }
  }

  const handleOrder = (orderBy, orderType) => {
    setOrderBy(orderBy);
    setOrderType(orderType);
  };

  const handlePageChange = (page) => {
    setSelectedPage(page);
  };

  const openChangeStateClasse = async (classe) => {
    setSelectedClasse(classe)
    setModalStateClassi(state => ({ ...state, showModalUpdateStateClasse: true }));
  }

  const renderChangeState = () => (
    <div>
      <span className="fs-5 d-block mb-3" style={{wordBreak: "break-word"}}>
        Vuoi {selectedClasse?.stato === "Attivo" ? "disattivare" : "attivare"} la classe "<b>{selectedClasse?.denominazione}</b>"?
      </span>
      <div className="alert alert-primary">
        <i className="bi bi-info-circle me-2"></i>
        Cambiando lo stato della classe, il corso "<b>{selectedClasse?.corso?.denominazione}</b>" {selectedClasse?.stato === "Attivo" ? "non sarà più" : "diventerà"} visibile e acquistabile dagli utenti sulla piattaforma.
      </div>
    </div>
  );

  const actions = [
    {
      label: ACTION_TYPES.DETAILS,
      icon: 'bi-info-circle text-dark',
      tooltip: ACTION_TYPES.DETAILS,
      type: ACTION_TYPES.VIEW,
      condition: () => true,
      onClick: (classe) => openInfoModal(classe)
    },
    {
      label: "Utenti",
      icon: 'bi-people-fill',
      type: ACTION_TYPES.CONFIG,
      condition: () => true,
      onClick: (classe) => navigate("/gestione-classi-utenti", {state: {classeData: classe}})
    },
    {
      label: "Lezioni",
      icon: 'bi-calendar-week',
      type: ACTION_TYPES.CONFIG,
      condition: (classe) => classe?.data_inizio && classe?.data_fine,
      onClick: (classe) => navigate("/configura-lezioni", {state: {courseData: classe}})
    },
    {
      label: "Esami",
      icon: 'bi-calendar-event',
      type: ACTION_TYPES.CONFIG,
      condition: (classe) => classe?.data_inizio && classe?.data_fine,
      onClick: (classe) => navigate("/configura-esami", {state: {classeData: classe}})
    },
    {
      label: "Registro Presenze",
      icon: 'bi-clipboard-check',
      type: ACTION_TYPES.CONFIG,
      condition: (classe) => classe?.data_inizio && classe?.data_fine,
      onClick: (classe) => navigate("/registro-presenze", {state: {classeData: classe}})
    },
    {
      label: ACTION_TYPES.UPDATE,
      icon: 'bi-pencil-fill text-warning',
      tooltip: ACTION_TYPES.UPDATE,
      type: ACTION_TYPES.MANAGER,
      condition: () => true,
      onClick: (classe) => openEditModal(classe)
    },
    {
      label: ACTION_TYPES.DELETE,
      icon: 'bi-trash-fill text-danger',
      tooltip: ACTION_TYPES.DELETE,
      type: ACTION_TYPES.MANAGER,
      condition: () => true,
      onClick: (classe) => openDeleteModal(classe)
    },
    {
      label: "Stato",
      icon: (classe) => classe.stato === "Attivo" ? "bi-toggle-on text-success" : "bi-toggle-off text-danger",
      type: ACTION_TYPES.MANAGER,
      condition: () => userLoggedIn.role === ROLES.ADMIN || userLoggedIn.role === ROLES.COURSE_DESIGNER || userLoggedIn.role === ROLES.DEVELOPER,
      onClick: (classe) => openChangeStateClasse(classe)
    }
  ];

  return (
    <>
        <div className={`card custom-card w-100 shadow ${isWideScreen ? 'p-5' : 'px-1 py-3'}`} style={{minHeight: '700px'}}>
            <div className='container'>
              <div className='d-flex justify-content-between custom-card-header'>
                <div className='d-flex gap-3 custom-card-title my-2'>
                  <div className={`custom-icon-container`}>
                    <i className={`bi custom-icon bi-person-workspace fs-2`}></i>
                  </div>
                  <div className='align-self-center'>
                    <span className='fs-4 d-block'><i><b>Gestione classi</b></i></span>
                  </div>
                </div>
                <div className='align-self-center my-2'>
                  <button type='button' className='btn btn-primary' onClick={openModalCreateClasse}>Crea classe</button>
                </div>
              </div>
              <div className='mt-5'>
                <CustomFilterTable 
                  formDataFilter={formDataFilter}
                  setFormDataFilter={setFormDataFilter}
                  onFilteredTable={onFilteredTable}
                  isLoadingData={loadingStateClassi.isLoadingClassiByParams}
                  searchNodeType={[
                    {nodeType: "input", name: "denominazione_corso", placeholder: "Denominazione corso"},
                    {nodeType: "date", name: "data_inizio", placeholder: "Data inizio"},
                    {nodeType: "date", name: "data_fine", placeholder: "Data fine"},
                  ]}
                />
              </div>
              {  !loadingStateClassi.isLoadingClassiByParams ? ( 
                  <>
             {(!classi || classi?.length === 0) ? (
                    <div className='mt-5 pt-5 text-center'>
                        <p>Non ci sono classi da mostrare.</p>
                    </div>) : (
                      <>
              <CustomTable
                data={classi}
                actions={actions}
                columns={classiConfigTable}
                handleOrder={handleOrder}
                orderBy={orderBy}
                orderType={orderType}
              />
              <div className="d-flex justify-content-end mt-1">
                <CustomPagination
                  totalPages={totalPages}
                  selectedPage={selectedPage}
                  handlePageChange={handlePageChange}
                />
              </div>
                      </>

                    )}
                  </>
              ) : (
                <LoadingTable loadingCol={4} />
              ) }
              <>
              </>
            </div>
        </div>
         <CustomModal
          show={modalStateClassi.showModalCreateClasse}
          onHide={handleCloseModal}
          headerText="Crea classe"
          size={"md"}
          btnText={"Crea classe"}
          body={
          <ClasseManagerForm 
            formClasseManager={formCreateClasse}
            setFormClasseManager={setFormCreateClasse}
            showModalClasseManager={modalStateClassi.showModalCreateClasse}
          />
        
        } 
          isLoading={loadingStateClassi.isLoadingClasseCreating}
          closeButton={true}
          onUndoChanges={handleCloseModal}
          onSave={onCreateClasse} 
        />
         <CustomModal
          show={modalStateClassi.showModalUpdateClasse}
          onHide={handleCloseModal}
          headerText="Modifica classe"
          size={"md"}
          btnText={"Salva modifiche"}
          body={
            <ClasseManagerForm 
              formClasseManager={formCreateClasse}
              setFormClasseManager={setFormCreateClasse}
              showModalClasseManager={modalStateClassi.showModalUpdateClasse}
              isUpdateMode={true}
            />
          } 
          isLoading={loadingStateClassi.isLoadingClasseUpdate}
          closeButton={true}
          onUndoChanges={handleCloseModal}
          onSave={onUpdateClasse} 
        />
         <CustomModal
          show={modalStateClassi.showModalDeleteClasse}
          onHide={handleCloseModal}
          headerText="Elimina classe"
          size={"md"}
          variant={"danger"}
          btnText={"Elimina"}
          body={renderSelectedDeleteClasse()} 
          isLoading={loadingStateClassi.isLoadingClasseDelete}
          closeButton={true}
          onUndoChanges={handleCloseModal}
          onSave={onDeleteClasse} 
        />
         <CustomModal
          show={modalStateClassi.showModalInfoClasse}
          onHide={handleCloseModal}
          headerText="Informazioni classe"
          size={"lg"}
          hideSaveBtn={true}
          body={<ClassInfo classeData={selectedClasse} />} 
          closeButton={true}
          onUndoChanges={handleCloseModal}
        />
        <CustomModal
          show={modalStateClassi.showModalUpdateStateClasse}
          onHide={handleCloseModal}
          headerText="Aggiorna stato"
          size={"md"}
          btnText={selectedClasse?.stato === "Attivo" ? "Disattiva" : "Attiva"}
          variant={"success"}
          body={renderChangeState()} 
          isLoading={loadingStateClassi.isLoadingUpdateStateClasse}
          closeButton={true}
          onUndoChanges={handleCloseModal}
          onSave={onUpdateStateClasse} 
        />
      </>
  )

}

export default GestioneClassiPageV2;
